export type Gradients = {
  bubblegum: string
  green2lightblue: string
  blue2indigo: string
  buttonNormal: string
  buttonHover: string
  buttonLoading: string
  swapBorder: string
  walletMenuBg: string
}

export type Feedbacks = {
  successText: string
  successBg: string
  dangerText: string
  dangerBg: string
  warningText: string
  warningBg: string
  infoText: string
  infoBg: string
  disableText: string
  disableBg: string
  iconWarningUnstake: string
}

export type Shadows = {
  settings: string
  navbar: string
}

export type Status = {
  open: string
  completed: string
  closed: string
}

export type Difficulty = {
  beginner: string
  intermediate: string
  advanced: string
}

export type Chart = {
  lineColor: string
  areaColor: string
  bar1Color: string
  bar2Color: string
  yAxisColor: string
  yAxis1Color: string
  yAxis2Color: string
  xAxisColor: string
  gradientArea: string
  stopColorOne?: string
  stopColorTwo?: string
}

type RoiCalculator = {
  background: string
  footerBackground: string
  footerHeaderText: string
  footerDetailsText: string
}

export type ColorsV2 = {
  background: string
  secondary: string
  main: string
  main2: string
  main3: string
  main4: string
  main5: string
  main6: string
  mainNonTransparent: string
  dark: string
  dark2: string
  light: string
  lightGreen: string
  loadingFirst: string
  loadingSecond: string
  text: string
  textSecondary: string
  textThirdly: string
  textLink: string
  textDisabled: string
  textInfo: string
  textWarning: string
  textButton: string
  textDanger: string
  success: string
  danger: string
  warningBg: string
  tagBg: string
  bannerBg: string
  tagText: string
  exploreIndicator: string
  exploreIndicatorActive: string
  borderLine: string
  // Gradients
  gradients: Gradients

  // Chart
  chart?: Chart

  // Feedbacks
  feedbacks: Feedbacks

  // InfoCard
  infoCard: InfoCard

  // Button
  button: Button

  referralDashboard?: { main2: string }

  // swap card
  swap: {
    background: string
    migrationBannerBackground: string
    migrationBannerBtnColor: string
  }

  // Shadows
  shadows: Shadows

  // quest question status
  statusPill: {
    background: Status
    text: Status
  }
  difficultyPill: {
    background: Difficulty
    text: Difficulty
  }
  roiCalculator: RoiCalculator
}

type InfoCard = {
  infoText: string
  infoBg: string
}

type Button = {
  primaryBg: string
  secondaryBg: string
  tertiaryBg: string
  quaternaryBg: string
  dangerBg: string
  disabledBg: string
  primaryText: string
  quaternaryText: string
  dangerText: string
  linkText: string
  disabledText: string
  radioOptionBg: string
  radioOptionText: string
  radioSelectedBg: string
  radioSelectedText: string
}

export const lightColorsV2: ColorsV2 = {
  background: '#FFFFFF',
  secondary: '#00FFB9',
  main: '#FFFFFF',
  main2: '#FFFFFFCC',
  main3: '#F9EEFF80',
  main4: '#00DAFF',
  main5: '#5A5A5AB2',
  main6: '#ADADAD',
  mainNonTransparent: '#FFFFFF',
  dark: '#F2F7FA',
  dark2: '#F2F2F2',
  light: '#E0E0E0',
  lightGreen: '#050A5A',
  loadingFirst: '#D4DEE3',
  loadingSecond: '#C7D5DB',
  text: '#5A5A5A',
  textSecondary: '#5A5A5AB2',
  textThirdly: '#B67CFF',
  textLink: '#0074FF',
  textDisabled: '#77777780',
  textInfo: '#4F8AE3',
  textWarning: '#F0AF41',
  textButton: '#FFF',
  textDanger: '#ED756E',
  success: '#56A944',
  danger: '#ED756E',
  warningBg: '#FEF8EE',
  tagBg: '#4F8AE3CC',
  bannerBg: '#F2F2F2',
  tagText: '#DEEFFF',
  exploreIndicator: '#459DEE',
  exploreIndicatorActive: '#459DEE',
  borderLine: '#E0E0E0',

  chart: {
    areaColor: 'transparent',
    bar1Color: '#CFA9FF',
    bar2Color: '#F2F2F2',
    lineColor: '#8AC0FF',
    xAxisColor: '#5A5A5AB2',
    yAxisColor: '#77777780',
    yAxis1Color: '#77777780',
    yAxis2Color: '#77777780',
    gradientArea: '77777780',
  },

  gradients: {
    bubblegum: 'linear-gradient(139.73deg, #00DAFF 0%, #00FFB9 100%)',
    green2lightblue: 'linear-gradient(90deg, #00CB82 -2.21%, #00B4ED 100%)',
    blue2indigo: 'linear-gradient(90deg, #3580FE -2.21%, #A633FE 100%)',
    walletMenuBg: 'linear-gradient(90deg, #3580FE -2.21%, #A633FE 100%)',
    buttonNormal: 'linear-gradient(90deg, #00CB82 -2.21%, #00B4ED 100%)',
    buttonHover: 'linear-gradient(90deg, rgba(0, 203, 130, 0.5) -2.21%, rgba(0, 180, 237, 0.5) 100%)',
    buttonLoading: 'linear-gradient(90deg, rgba(0, 203, 130, 0.5) -2.21%, rgba(0, 180, 237, 0.5) 100%)',
    swapBorder: 'linear-gradient(90deg, #77acff -2.21%, #c578ff 89.35%);',
  },
  feedbacks: {
    successText: '#56A944',
    successBg: '#C8EFD04D',
    dangerText: '#ED756E',
    dangerBg: '#FFB2C04D',
    warningText: '#F0AF41',
    warningBg: '#F1F2A9',
    infoText: '#4F8AE3',
    infoBg: '#DEEFFF',
    disableText: '#FFFFFF80',
    disableBg: '#E0E0E0',
    iconWarningUnstake: '#4F8AE3',
  },
  infoCard: {
    infoText: '#4F8AE3',
    infoBg: '#DEEFFF',
  },
  button: {
    primaryBg: 'linear-gradient(90deg, #3580FE -2.21%, #A633FE 100%)',
    secondaryBg: '#77777780',
    tertiaryBg: '#15152E99',
    quaternaryBg: '#DEEFFF',
    quaternaryText: '#4F8AE3',
    dangerBg: '#FFB2C04D',
    disabledBg: '#E0E0E0',
    primaryText: '#FFFFFF',
    dangerText: '#ED756E',
    linkText: '#0074FF',
    disabledText: '#77777780',
    radioOptionBg: '#F2F2F2',
    radioOptionText: '#5A5A5AB2',
    radioSelectedBg: '#0AC6E5',
    radioSelectedText: '#FAFAFA',
  },
  swap: {
    background: '#FFFFFF',
    migrationBannerBackground: 'linear-gradient(90.2deg, #EFE7F3 26.53%, #E0E2F7 71.19%)',
    migrationBannerBtnColor: '#FFFFFF',
  },
  shadows: {
    settings: '0px 0px 25px #d4cbdca6',
    navbar: '0px 4px 20px 0px #003D9814',
  },
  statusPill: {
    background: {
      open: '#4F8AE3',
      completed: '#56A944',
      closed: '#E0E0E0',
    },
    text: {
      open: '#FFFFFF',
      completed: '#FFFFFF',
      closed: '#777777',
    },
  },
  difficultyPill: {
    background: {
      beginner: '#C8EFD04D',
      intermediate: '#FEF8EE',
      advanced: '#FFB3C0',
    },
    text: {
      beginner: '#56A944',
      intermediate: '#F5B452',
      advanced: '#ED756E',
    },
  },
  roiCalculator: {
    background: '#FFFFFF',
    footerBackground: '#F5FAFF',
    footerHeaderText: '#4F8AE3',
    footerDetailsText: '#4F8AE3',
  },
}

export const darkColorsV2: ColorsV2 = {
  background: '#F2F4F5',
  secondary: '#00FFB9',
  main: '#2E3466',
  main2: '#2E3466CC',
  main3: '#2E346666',
  main4: '#00DAFF',
  main5: '#BDC2FF',
  main6: '#BDC2FF',
  mainNonTransparent: '#282d5a',
  dark: '#15152E',
  dark2: '#15152E99',
  light: '#555A9B',
  lightGreen: '#050A5A',
  loadingFirst: '#555A9B',
  loadingSecond: '#ACACBB',
  text: '#FAFAFA',
  textSecondary: '#FAFAFAB2',
  textThirdly: '#BDC2FF',
  textLink: '#0AC6E5',
  textDisabled: '#555A9B',
  textWarning: '#F0AF41',
  textButton: '#FFF',
  textDanger: '#F1878D',
  textInfo: '#24C7EB',
  success: '#00D279',
  danger: '#FF8799',
  warningBg: '#58535A',
  tagBg: '#2E3466CC',
  bannerBg: '#252952',
  tagText: '#FAFAFAB2',
  exploreIndicator: '#555A9B',
  exploreIndicatorActive: '#BDC2FF',
  borderLine: '#596187',

  gradients: {
    bubblegum: 'linear-gradient(139.73deg, #00DAFF 0%, #00FFB9 100%)',
    green2lightblue: 'linear-gradient(90deg, #12ECB8 -2.21%, #00B4ED 92.02%)',
    blue2indigo: 'linear-gradient(90deg, #0063FF -2.21%, #9100FF 89.35%)',
    walletMenuBg: 'linear-gradient(90deg, #0063FF -2.21%, #9100FF 89.35%)',
    buttonNormal: 'linear-gradient(90deg, #00CB82 -2.21%, #00B4ED 100%)',
    buttonHover: 'linear-gradient(90deg, rgba(0, 203, 130, 0.5) -2.21%, rgba(0, 180, 237, 0.5) 100%)',
    buttonLoading: 'linear-gradient(90deg, rgba(0, 203, 130, 0.5) -2.21%, rgba(0, 180, 237, 0.5) 100%)',
    swapBorder: 'linear-gradient(146.07deg, #5094FF 4.09%, #0063FF 9.96%, #810BFF 85.5%, #6500B3 94.55%);',
  },

  chart: {
    areaColor: '#47B8E812',
    bar1Color: '#7D4EB9',
    bar2Color: '#2E346666',
    lineColor: '#477EE8',
    xAxisColor: '#2E3466',
    yAxisColor: '#77777780',
    yAxis1Color: '#77777780',
    yAxis2Color: '#77777780',
    gradientArea: '77777780',
  },

  feedbacks: {
    successText: '#00D279',
    successBg: '#0B58204D',
    dangerText: '#FF8799',
    dangerBg: '#580B0B4D',
    warningText: '#F0AF41',
    warningBg: '#F0AF4199',
    infoText: '#24C7EB',
    infoBg: '#005FB74D',
    disableText: '#FAFAFA',
    disableBg: '#555A9B',
    iconWarningUnstake: '#4F8AE3',
  },
  infoCard: {
    infoBg: '#BDC2FF0F',
    infoText: '#BDC2FF',
  },
  button: {
    primaryBg: 'linear-gradient(90deg, #0063FF -2.21%, #9100FF 89.35%)',
    secondaryBg: '#555A9B',
    tertiaryBg: '#15152E99',
    quaternaryBg: '#BDC2FF80',
    quaternaryText: '#FFFFFF',
    dangerBg: '#580B0B4D',
    disabledBg: '#555A9B',
    primaryText: '#FFFFFF',
    linkText: '#0AC6E5',
    dangerText: '#FF8799',
    disabledText: '#FAFAFA4D',
    radioOptionBg: '#555A9B',
    radioOptionText: '#FAFAFA',
    radioSelectedBg: '#0AC6E5',
    radioSelectedText: '#FAFAFA',
  },
  swap: {
    background: '#2E3466',
    migrationBannerBackground: 'linear-gradient(90.14deg, #1B3457 27.85%, #2A1A48 71.77%)',
    migrationBannerBtnColor: '#2E3466',
  },
  shadows: {
    settings: '0px 0px 25px #1D003A',
    navbar: '0px 1px 0px 0px #2B3160',
  },
  statusPill: {
    background: {
      open: '#24C7EB',
      completed: '#00D279',
      closed: '#555A9B',
    },
    text: {
      open: '#2E3466',
      completed: '#2E3466',
      closed: '#868AB7',
    },
  },
  difficultyPill: {
    background: {
      beginner: '#0B58204D',
      intermediate: '#58545B',
      advanced: '#3A284B',
    },
    text: {
      beginner: '#00D279',
      intermediate: '#F0AF41',
      advanced: '#FF8799',
    },
  },
  roiCalculator: {
    background: '#2E3466',
    footerBackground: '#1F2144',
    footerHeaderText: '#FAFAFA',
    footerDetailsText: '#B8B9C3',
  },
}

export const beamColorsV2: ColorsV2 = {
  background: '#1A1B1F',
  secondary: '#00FFB9',
  main: '#282A33',
  main2: '#14151A',
  main3: '#20222A',
  main4: '#6976CD',
  main5: '#FAFAFA',
  main6: '#8E969A',
  mainNonTransparent: '#14151A',
  dark: '#1A1B1F',
  dark2: '#383F5B',
  light: '#596187',
  lightGreen: '#050A5A',
  loadingFirst: '#555A9B',
  loadingSecond: '#ACACBB',
  text: '#FAFAFA',
  textSecondary: '#91969A',
  textThirdly: '#6976CD',
  textLink: '#8692FF',
  textDisabled: '#444E60',
  textWarning: '#F0AF41',
  textButton: '#FFF',
  textDanger: '#F1878D',
  textInfo: '#FAFAFA',
  success: '#00D279',
  tagBg: '#6976cd80',
  bannerBg: '#282A33',
  tagText: '#FAFAFA',
  danger: '#FF8799',
  warningBg: '#58535A',
  exploreIndicator: '#555A9B',
  exploreIndicatorActive: '#BDC2FF',
  borderLine: '#383F5B',

  gradients: {
    bubblegum: 'linear-gradient(139.73deg, #00DAFF 0%, #00FFB9 100%)',
    green2lightblue: '#8692FF',
    blue2indigo: 'linear-gradient(90deg, #0063FF -2.21%, #9100FF 89.35%)',
    walletMenuBg: 'linear-gradient(180deg, #434D76 0%, #5B629E 100%)',
    buttonNormal: 'linear-gradient(90deg, #00CB82 -2.21%, #00B4ED 100%)',
    buttonHover: 'linear-gradient(90deg, rgba(0, 203, 130, 0.5) -2.21%, rgba(0, 180, 237, 0.5) 100%)',
    buttonLoading: 'linear-gradient(90deg, rgba(0, 203, 130, 0.5) -2.21%, rgba(0, 180, 237, 0.5) 100%)',
    swapBorder: 'linear-gradient(146.07deg, #5094FF 4.09%, #0063FF 9.96%, #810BFF 85.5%, #6500B3 94.55%);',
  },

  feedbacks: {
    successText: '#6EC25C',
    successBg: '#0B58204D',
    dangerText: '#ED756E',
    dangerBg: '#580B0B4D',
    warningText: '#F5B452',
    warningBg: '#F0AF414D',
    infoText: '#4F8AE3',
    infoBg: '#282A33',
    disableText: '#FFFFFF4D',
    disableBg: '#444E60',
    iconWarningUnstake: '#6976CD',
  },
  infoCard: {
    infoBg: '#BDC2FF0F',
    infoText: '#BDC2FF',
  },
  button: {
    primaryBg: 'linear-gradient(180deg, #434D76 0%, #5B629E 100%)',
    secondaryBg: '#555A9B',
    tertiaryBg: '#15152E99',
    quaternaryBg: '#BDC2FF80',
    quaternaryText: '#FFFFFF',
    dangerBg: '#580B0B4D',
    disabledBg: '#3a3d4de6',
    primaryText: '#FFFFFF',
    linkText: '#8692FF',
    dangerText: '#FF8799',
    disabledText: '#FAFAFA4D',
    radioOptionBg: '#555A9B',
    radioOptionText: '#FAFAFA',
    radioSelectedBg: '#0AC6E5',
    radioSelectedText: '#FAFAFA',
  },
  swap: {
    background: '#2E3466',
    migrationBannerBackground: 'linear-gradient(90.14deg, #1B3457 27.85%, #2A1A48 71.77%)',
    migrationBannerBtnColor: '#2E3466',
  },
  shadows: {
    settings: '0px 0px 25px 0px #0024a426',
    navbar: '0px 4px 20px 0px rgba(0, 61, 152, 0.08)',
  },
  statusPill: {
    background: {
      open: '#FAFAFA',
      completed: '#00D279',
      closed: '#555A9B',
    },
    text: {
      open: '#2E3466',
      completed: '#2E3466',
      closed: '#868AB7',
    },
  },
  difficultyPill: {
    background: {
      beginner: '#0B58204D',
      intermediate: '#58545B',
      advanced: '#3A284B',
    },
    text: {
      beginner: '#00D279',
      intermediate: '#F0AF41',
      advanced: '#FF8799',
    },
  },
  roiCalculator: {
    background: '#2E3466',
    footerBackground: '#1F2144',
    footerHeaderText: '#FAFAFA',
    footerDetailsText: '#B8B9C3',
  },
}

export const aethirColorsV2: ColorsV2 = {
  background: '#FFFFFF',
  secondary: '#00FFB9',
  main: '#FFFFFF',
  main2: '#FFFFFFCC',
  main3: '#E9F5FE',
  main4: '#000',
  main5: '#000000',
  main6: '#ADADAD',
  mainNonTransparent: '#FFFFFF',
  dark: '#F9F9F9',
  dark2: '#F2F2F2',
  light: '#E0E0E0',
  lightGreen: '#050A5A',
  loadingFirst: '#D4DEE3',
  loadingSecond: '#C7D5DB',
  text: '#5A5A5A',
  textSecondary: '#8A8A8A',
  textThirdly: '#000000',
  textLink: '#000',
  textDisabled: '#ADADAD',
  textInfo: '#4F8AE3',
  textWarning: '#F0AF41',
  textButton: '#FFF',
  textDanger: '#ED756E',
  success: '#56A944',
  danger: '#ED756E',
  warningBg: '#FEF8EE',
  tagBg: '#4B7EFFCC',
  bannerBg: '#252952',
  tagText: '#FFFFFF',
  exploreIndicator: '#4F8AE3',
  exploreIndicatorActive: '#4F8AE3',
  borderLine: '#E0E0E0',

  chart: lightColorsV2.chart,

  gradients: {
    bubblegum: 'linear-gradient(139.73deg, #00DAFF 0%, #00FFB9 100%)',
    green2lightblue: 'linear-gradient(90deg, #1273EA 0%, #1C94F4 100%)',
    blue2indigo: 'linear-gradient(90deg, #3580FE -2.21%, #A633FE 100%)',
    walletMenuBg: 'linear-gradient(90deg, #3580FE -2.21%, #A633FE 100%)',
    buttonNormal: 'linear-gradient(90deg, #00CB82 -2.21%, #00B4ED 100%)',
    buttonHover: 'linear-gradient(90deg, rgba(0, 203, 130, 0.5) -2.21%, rgba(0, 180, 237, 0.5) 100%)',
    buttonLoading: 'linear-gradient(90deg, rgba(0, 203, 130, 0.5) -2.21%, rgba(0, 180, 237, 0.5) 100%)',
    swapBorder: 'linear-gradient(90deg, #77acff -2.21%, #c578ff 89.35%);',
  },
  feedbacks: {
    successText: '#6EC25C',
    successBg: '#C8EFD04D',
    dangerText: '#ED756E',
    dangerBg: '#FFB2C04D',
    warningText: '#F5B452',
    warningBg: '#FEF8EE4D',
    infoText: '#4F8AE3',
    infoBg: '#DEEFFF',
    disableText: '#ADADAD',
    disableBg: '#E0E0E0',
    iconWarningUnstake: '#4F8AE3',
  },
  infoCard: {
    infoText: '#4F8AE3',
    infoBg: '#DEEFFF',
  },
  button: {
    primaryBg: '#000',
    secondaryBg: '#00000080',
    tertiaryBg: '#15152E99',
    quaternaryBg: '#DEEFFF',
    quaternaryText: '#4F8AE3',
    dangerBg: '#FFB2C04D',
    disabledBg: '#E0E0E0',
    primaryText: '#FFFFFF',
    dangerText: '#ED756E',
    linkText: '#0074FF',
    disabledText: '#77777780',
    radioOptionBg: '#F2F2F2',
    radioOptionText: '#5A5A5AB2',
    radioSelectedBg: '#0AC6E5',
    radioSelectedText: '#FAFAFA',
  },
  swap: {
    background: '#FFFFFF',
    migrationBannerBackground: 'linear-gradient(90.2deg, #EFE7F3 26.53%, #E0E2F7 71.19%)',
    migrationBannerBtnColor: '#FFFFFF',
  },
  shadows: {
    settings: '0px 4px 25px 0px #0024a426',
    navbar: '0px 4px 25px 0px  rgba(151, 151, 151, 0.15)',
  },
  statusPill: {
    background: {
      open: '#4F8AE3',
      completed: '#56A944',
      closed: '#E0E0E0',
    },
    text: {
      open: '#FFFFFF',
      completed: '#FFFFFF',
      closed: '#777777',
    },
  },
  difficultyPill: {
    background: {
      beginner: '#C8EFD04D',
      intermediate: '#FEF8EE',
      advanced: '#FFB3C0',
    },
    text: {
      beginner: '#56A944',
      intermediate: '#F5B452',
      advanced: '#ED756E',
    },
  },
  roiCalculator: {
    background: '#FFFFFF',
    footerBackground: '#F5FAFF',
    footerHeaderText: '#4F8AE3',
    footerDetailsText: '#4F8AE3',
  },
}

export const blueColorsV2: ColorsV2 = {
  background: '#FFFFFF',
  secondary: '#00FFB9',
  main: '#FFFFFF',
  main2: '#FFFFFFCC',
  main3: '#E9F5FE',
  main4: '#4B7EFF',
  main5: '#4F8AE3',
  main6: '#ADADAD',
  mainNonTransparent: '#FFFFFF',
  dark: '#F2F7FA',
  dark2: '#F2F2F2',
  light: '#E0E0E0',
  lightGreen: '#050A5A',
  loadingFirst: '#D4DEE3',
  loadingSecond: '#C7D5DB',
  text: '#5A5A5A',
  textSecondary: '#8A8A8A',
  textThirdly: '#4F8AE3',
  textLink: '#0074FF',
  textDisabled: '#ADADAD',
  textInfo: '#4F8AE3',
  textWarning: '#F0AF41',
  textButton: '#FFF',
  textDanger: '#ED756E',
  success: '#38AF1F',
  danger: '#ED756E',
  warningBg: '#FEF8EE',
  tagBg: '#4B7EFFCC',
  bannerBg: '#FFF',
  tagText: '#FFFFFF',
  exploreIndicator: '#4F8AE3',
  exploreIndicatorActive: '#4F8AE3',
  borderLine: '#E0E0E0',

  gradients: {
    bubblegum: 'linear-gradient(139.73deg, #00DAFF 0%, #00FFB9 100%)',
    green2lightblue: 'linear-gradient(90deg, rgb(18, 115, 234) 0%, rgb(28, 148, 244) 100%)',
    blue2indigo: 'linear-gradient(90deg, #3580FE -2.21%, #A633FE 100%)',
    walletMenuBg: 'linear-gradient(90deg, #1273ea 0%, #1c94f4 100%)',
    buttonNormal: 'linear-gradient(90deg, #00CB82 -2.21%, #00B4ED 100%)',
    buttonHover: 'linear-gradient(90deg, rgba(0, 203, 130, 0.5) -2.21%, rgba(0, 180, 237, 0.5) 100%)',
    buttonLoading: 'linear-gradient(90deg, rgba(0, 203, 130, 0.5) -2.21%, rgba(0, 180, 237, 0.5) 100%)',
    swapBorder: 'linear-gradient(90deg, #77acff -2.21%, #c578ff 89.35%);',
  },
  feedbacks: {
    successText: '#6EC25C',
    successBg: '#C8EFD04D',
    dangerText: '#ED756E',
    dangerBg: '#FFB2C04D',
    warningText: '#F5B452',
    warningBg: '#FEF8EE4D',
    infoText: '#4F8AE3',
    infoBg: '#DEEFFF',
    disableText: '#ADADAD',
    disableBg: '#E0E0E0',
    iconWarningUnstake: '#4F8AE3',
  },
  infoCard: {
    infoText: '#4F8AE3',
    infoBg: '#DEEFFF',
  },
  button: {
    primaryBg: 'linear-gradient(90deg, #1273EA -2.21%, #1C94F4 100%)',
    secondaryBg: '#FFFFFF',
    tertiaryBg: '#15152E99',
    quaternaryBg: '#DEEFFF',
    quaternaryText: '#4F8AE3',
    dangerBg: '#FFB2C04D',
    disabledBg: '#E0E0E0',
    primaryText: '#FFFFFF',
    dangerText: '#ED756E',
    linkText: '#0074FF',
    disabledText: '#77777780',
    radioOptionBg: '#F2F2F2',
    radioOptionText: '#5A5A5AB2',
    radioSelectedBg: '#0AC6E5',
    radioSelectedText: '#FAFAFA',
  },
  swap: {
    background: '#FFFFFF',
    migrationBannerBackground: 'linear-gradient(90.2deg, #EFE7F3 26.53%, #E0E2F7 71.19%)',
    migrationBannerBtnColor: '#FFFFFF',
  },
  shadows: {
    settings: '0px 4px 25px 0px #0024a426',
    navbar: '0px 4px 20px 0px #003D9814',
  },
  statusPill: {
    background: {
      open: '#4F8AE3',
      completed: '#56A944',
      closed: '#E0E0E0',
    },
    text: {
      open: '#FFFFFF',
      completed: '#FFFFFF',
      closed: '#777777',
    },
  },
  difficultyPill: {
    background: {
      beginner: '#C8EFD04D',
      intermediate: '#FEF8EE',
      advanced: '#FFB3C0',
    },
    text: {
      beginner: '#56A944',
      intermediate: '#F5B452',
      advanced: '#ED756E',
    },
  },
  chart: lightColorsV2.chart,
  roiCalculator: {
    background: '#FFFFFF',
    footerBackground: '#F5FAFF',
    footerHeaderText: '#4F8AE3',
    footerDetailsText: '#4F8AE3',
  },
}

export const carvColorsV2: ColorsV2 = {
  background: '#170528',
  secondary: '#FFFFFF',
  main: '#2A2732',
  main2: '#15161B',
  main3: '#231D2B',
  main4: '#A984FDCC',
  main5: '#8A5AFF',
  main6: '#A69DBE',
  mainNonTransparent: '#FFFFFF',
  dark: '#0B0B0B',
  dark2: '#5A498059',
  light: '#523e8b80',
  lightGreen: '#050A5A',
  loadingFirst: '#D4DEE3',
  loadingSecond: '#C7D5DB',
  text: '#FAFAFA',
  textSecondary: '#A69DBE',
  textThirdly: '#9466F2',
  textLink: '#0074FF',
  textDisabled: '#5E537F',

  textInfo: '#6F6DEB',
  textWarning: '#F0AF41',
  textButton: '#FFF',
  textDanger: '#580B0B',
  success: '#0B5820',
  danger: '#ED756E',
  warningBg: '#F0AF41',
  tagBg: '#4B7EFFCC',
  bannerBg: '#2A2732',
  tagText: '#FFFFFF',
  exploreIndicator: '#4F8AE3',
  exploreIndicatorActive: '#4F8AE3',
  borderLine: '#523e8b80',

  gradients: {
    bubblegum: 'linear-gradient(139.73deg, #00DAFF 0%, #00FFB9 100%)',
    green2lightblue: '#8A5AFF',
    blue2indigo: 'linear-gradient(90deg, #3580FE -2.21%, #A633FE 100%)',
    walletMenuBg: 'linear-gradient(90deg, #1273ea 0%, #1c94f4 100%)',
    buttonNormal: 'linear-gradient(90deg, #00CB82 -2.21%, #00B4ED 100%)',
    buttonHover: 'linear-gradient(90deg, rgba(0, 203, 130, 0.5) -2.21%, rgba(0, 180, 237, 0.5) 100%)',
    buttonLoading: 'linear-gradient(90deg, rgba(0, 203, 130, 0.5) -2.21%, rgba(0, 180, 237, 0.5) 100%)',
    swapBorder: 'linear-gradient(90deg, #77acff -2.21%, #c578ff 89.35%);',
  },
  feedbacks: {
    successText: '#6EC25C',
    successBg: '#0b58204d',
    dangerText: '#ED756E',
    dangerBg: '#580b0b4d',
    warningText: '#F5B452',
    warningBg: '#FEF8EE4D',
    infoText: '#4F8AE3',
    infoBg: '#0007b74d',
    disableText: '#ADADAD',
    disableBg: '#443A4D',
    iconWarningUnstake: '#4F8AE3',
  },
  infoCard: {
    infoText: '#4F8AE3',
    infoBg: '#0007B7',
  },
  button: {
    primaryBg: '#8A5AFF',
    secondaryBg: '#FFFFFF',
    tertiaryBg: '#15152E99',
    quaternaryBg: '#DEEFFF',
    quaternaryText: '#4F8AE3',
    dangerBg: '#FFB2C04D',
    disabledBg: '#443A4D',
    primaryText: '#FFFFFF',
    dangerText: '#ED756E',
    linkText: '#0074FF',
    disabledText: '#77777780',
    radioOptionBg: '#F2F2F2',
    radioOptionText: '#5A5A5AB2',
    radioSelectedBg: '#0AC6E5',
    radioSelectedText: '#FAFAFA',
  },
  swap: {
    background: '#FFFFFF',
    migrationBannerBackground: 'linear-gradient(90.2deg, #EFE7F3 26.53%, #E0E2F7 71.19%)',
    migrationBannerBtnColor: '#FFFFFF',
  },
  shadows: {
    settings: '0px 4px 25px 0px #0024a426',
    navbar: '0px 4px 20px 0px #003D9814',
  },
  statusPill: {
    background: {
      open: '#4F8AE3',
      completed: '#56A944',
      closed: '#E0E0E0',
    },
    text: {
      open: '#FFFFFF',
      completed: '#FFFFFF',
      closed: '#777777',
    },
  },
  difficultyPill: {
    background: {
      beginner: '#C8EFD04D',
      intermediate: '#FEF8EE',
      advanced: '#FFB3C0',
    },
    text: {
      beginner: '#56A944',
      intermediate: '#F5B452',
      advanced: '#ED756E',
    },
  },
  roiCalculator: {
    background: '#FFFFFF',
    footerBackground: '#F5FAFF',
    footerHeaderText: '#4F8AE3',
    footerDetailsText: '#4F8AE3',
  },
  chart: lightColorsV2.chart,
}

export const particleColorsV2: ColorsV2 = {
  background: '#0C0A0D',
  secondary: '#FFFFFF',
  main: '#2A2732',
  main2: '#15161B',
  main3: '#231D2B',
  main4: '#B460FA',
  main5: '#B052FF',
  main6: '#A69DBE',
  mainNonTransparent: '#FFFFFF',
  dark: '#0B0B0B',
  dark2: '#393151',
  light: '#393151',
  lightGreen: '#050A5A',
  loadingFirst: '#D4DEE3',
  loadingSecond: '#C7D5DB',
  text: '#FAFAFA',
  textSecondary: '#A69DBE',
  textThirdly: '#B052FF',
  textLink: '#0074FF',
  textDisabled: '#5E537F',

  textInfo: '#956DEB',
  textWarning: '#F5B452',
  textButton: '#FFF',
  textDanger: '#ED756E',
  success: '#0B5820',
  danger: '#580B0B',
  warningBg: '#F0AF41',
  tagBg: '#4B7EFFCC',
  bannerBg: '#2A2732',
  tagText: '#FFFFFF',
  exploreIndicator: '#4F8AE3',
  exploreIndicatorActive: '#4F8AE3',
  borderLine: '#523e8b80',

  gradients: {
    bubblegum: 'linear-gradient(139.73deg, #00DAFF 0%, #00FFB9 100%)',
    green2lightblue: '#8A5AFF',
    blue2indigo: 'linear-gradient(90deg, #3580FE -2.21%, #A633FE 100%)',
    walletMenuBg: 'linear-gradient(90deg, #1273ea 0%, #1c94f4 100%)',
    buttonNormal: 'linear-gradient(90deg, #00CB82 -2.21%, #00B4ED 100%)',
    buttonHover: 'linear-gradient(90deg, rgba(0, 203, 130, 0.5) -2.21%, rgba(0, 180, 237, 0.5) 100%)',
    buttonLoading: 'linear-gradient(90deg, rgba(0, 203, 130, 0.5) -2.21%, rgba(0, 180, 237, 0.5) 100%)',
    swapBorder: 'linear-gradient(90deg, #77acff -2.21%, #c578ff 89.35%);',
  },
  feedbacks: {
    successText: '#2A2732',
    successBg: '#2A2732',
    dangerText: '#ED756E',
    dangerBg: '#580b0b4d',
    warningText: '#F5B452',
    warningBg: '#FEF8EE4D',
    infoText: '#4F8AE3',
    infoBg: '#0007b74d',
    disableText: '#ADADAD',
    disableBg: '#443A4D',
    iconWarningUnstake: '#4A74C6',
  },
  infoCard: {
    infoText: '#956DEB',
    infoBg: '#0007B7',
  },
  button: {
    primaryBg: '#8A5AFF',
    secondaryBg: '#FFFFFF',
    tertiaryBg: '#15152E99',
    quaternaryBg: '#DEEFFF',
    quaternaryText: '#4F8AE3',
    dangerBg: '#FFB2C04D',
    disabledBg: '#443A4D',
    primaryText: '#FFFFFF',
    dangerText: '#ED756E',
    linkText: '#0074FF',
    disabledText: '#77777780',
    radioOptionBg: '#F2F2F2',
    radioOptionText: '#5A5A5AB2',
    radioSelectedBg: '#0AC6E5',
    radioSelectedText: '#FAFAFA',
  },
  swap: {
    background: '#FFFFFF',
    migrationBannerBackground: 'linear-gradient(90.2deg, #EFE7F3 26.53%, #E0E2F7 71.19%)',
    migrationBannerBtnColor: '#FFFFFF',
  },
  shadows: {
    settings: '0px 4px 25px 0px #0024a426',
    navbar: '0px 4px 20px 0px #003D9814',
  },
  statusPill: {
    background: {
      open: '#4F8AE3',
      completed: '#56A944',
      closed: '#E0E0E0',
    },
    text: {
      open: '#FFFFFF',
      completed: '#FFFFFF',
      closed: '#777777',
    },
  },
  difficultyPill: {
    background: {
      beginner: '#0B0B0B',
      intermediate: '#FEF8EE',
      advanced: '#FFB3C0',
    },
    text: {
      beginner: '#170528',
      intermediate: '#F5B452',
      advanced: '#ED756E',
    },
  },
  roiCalculator: {
    background: '#FFFFFF',
    footerBackground: '#F5FAFF',
    footerHeaderText: '#B460FA',
    footerDetailsText: '#4F8AE3',
  },
  chart: {
    areaColor: 'transparent',
    bar1Color: '#5A498059',
    bar2Color: '#CFA9FF',
    lineColor: '#FE39DE',
    xAxisColor: '#5A5A5AB2',
    yAxisColor: '#77777780',
    yAxis1Color: '#77777780',
    yAxis2Color: '#77777780',
    gradientArea: 'linear-gradient(184deg, rgba(254, 57, 222, 0.35) 1%, rgba(254, 57, 222, 0.07) 94.95%)',
    stopColorOne: 'rgba(254, 57, 222, 0.35)',
    stopColorTwo: 'rgba(254, 57, 222, 0.07)',
  },
}

export const campusColors: ColorsV2 = {
  background: '#FFFFFF',
  secondary: '#FFFFFF',
  main: '#FFFFFF',
  main2: 'rgba(255, 255, 255, 0.80)',
  main3: '#FBFBFB',
  main4: '#07B475',
  main5: '#151BE2',
  main6: '#A69DBE',
  mainNonTransparent: '#07094A',
  dark: '#F9F9F9',
  dark2: '#DFE3FF',
  light: '#E9EBFA',
  lightGreen: '#050A5A',
  loadingFirst: '#D4DEE3',
  loadingSecond: '#C7D5DB',
  text: '#07094A',
  textSecondary: '#07094A',
  textThirdly: '#151BE2',
  textLink: '#0074FF',
  textDisabled: '#8091BD',

  textInfo: '#404EED',
  textWarning: '#F5B452',
  textButton: '#FFF',
  textDanger: '#ED756E',
  success: '#0B5820',
  danger: '#F25A67',
  warningBg: '#F0AF41',
  tagBg: '#4B7EFFCC',
  bannerBg: '#FFFFFF',
  tagText: '#FFFFFF',
  exploreIndicator: '#4F8AE3',
  exploreIndicatorActive: '#4F8AE3',
  borderLine: '#523e8b80',

  gradients: {
    bubblegum: 'linear-gradient(139.73deg, #00DAFF 0%, #00FFB9 100%)',
    green2lightblue: '#151BE2',
    blue2indigo: 'linear-gradient(90deg, #3580FE -2.21%, #A633FE 100%)',
    walletMenuBg: 'linear-gradient(90deg, #1273ea 0%, #1c94f4 100%)',
    buttonNormal: 'linear-gradient(90deg, #00CB82 -2.21%, #00B4ED 100%)',
    buttonHover: 'linear-gradient(90deg, rgba(0, 203, 130, 0.5) -2.21%, rgba(0, 180, 237, 0.5) 100%)',
    buttonLoading: 'linear-gradient(90deg, rgba(0, 203, 130, 0.5) -2.21%, rgba(0, 180, 237, 0.5) 100%)',
    swapBorder: 'linear-gradient(90deg, #77acff -2.21%, #c578ff 89.35%);',
  },
  feedbacks: {
    successText: '#6EC25C',
    successBg: '#FFFFFF',
    dangerText: '#ED756E',
    dangerBg: '#580b0b4d',
    warningText: '#F5B452',
    warningBg: '#FEF8EE4D',
    infoText: '#4F8AE3',
    infoBg: '#0007b74d',
    disableText: '#ADADAD',
    disableBg: '#8091BD',
    iconWarningUnstake: '#07b475',
  },
  infoCard: {
    infoText: '#956DEB',
    infoBg: '#0007B7',
  },
  button: {
    primaryBg: '#151BE2',
    secondaryBg: '#FFFFFF',
    tertiaryBg: '#DFE3FF',
    quaternaryBg: '#DEEFFF',
    quaternaryText: '#4F8AE3',
    dangerBg: '#FFB2C04D',
    disabledBg: '#DCE0FF',
    primaryText: '#FFFFFF',
    dangerText: '#ED756E',
    linkText: '#0074FF',
    disabledText: '#77777780',
    radioOptionBg: '#F2F2F2',
    radioOptionText: '#5A5A5AB2',
    radioSelectedBg: '#0AC6E5',
    radioSelectedText: '#FAFAFA',
  },
  swap: {
    background: '#FFFFFF',
    migrationBannerBackground: 'linear-gradient(90.2deg, #EFE7F3 26.53%, #E0E2F7 71.19%)',
    migrationBannerBtnColor: '#FFFFFF',
  },
  shadows: {
    settings: '0px 4px 25px 0px #0024a426',
    navbar: '0px 4px 20px 0px #003D9814',
  },
  statusPill: {
    background: {
      open: '#4F8AE3',
      completed: '#56A944',
      closed: '#E0E0E0',
    },
    text: {
      open: '#FFFFFF',
      completed: '#FFFFFF',
      closed: '#777777',
    },
  },
  difficultyPill: {
    background: {
      beginner: '#C8EFD04D',
      intermediate: '#FEF8EE',
      advanced: '#FFB3C0',
    },
    text: {
      beginner: '#F9F9F9',
      intermediate: '#F5B452',
      advanced: '#ED756E',
    },
  },
  roiCalculator: {
    background: '#07094A',
    footerBackground: '#F5FAFF',
    footerHeaderText: '#151BE2',
    footerDetailsText: '#4F8AE3',
  },
  chart: {
    areaColor: 'transparent',
    bar1Color: '#DFE3FF',
    bar2Color: '#151BE2',
    lineColor: '#8AC0FF',
    xAxisColor: '#5A5A5AB2',
    yAxisColor: '#77777780',
    yAxis1Color: '#77777780',
    yAxis2Color: '#77777780',
    gradientArea: 'linear-gradient(184deg, rgba(138, 192, 255, 0.35) 1%, rgba(138, 192, 255, 0.07) 94.95%)',
    stopColorOne: 'rgba(138, 192, 255, 0.35)',
    stopColorTwo: 'rgba(138, 192, 255, 0.07)',
  },
  referralDashboard: {
    main2: '#FFFFFF',
  },
}

export const moonveilColors: ColorsV2 = {
  background: '#000000',
  secondary: '#FFFFFF',
  main: '#111111',
  main2: '#14151A',
  main3: '#24231A',
  main4: '#BB8857',
  main5: '#D9B07A',
  main6: '#53514E',
  mainNonTransparent: '#FFFFFF',
  dark: '#000000',
  dark2: '#524B40',
  light: '#222222',
  lightGreen: '#050A5A',
  loadingFirst: '#D4DEE3',
  loadingSecond: '#C7D5DB',
  text: '#F6F6F6',
  textSecondary: '#9C9C9C',
  textThirdly: '#D2A17D',
  textLink: '#FFFFFF',
  textDisabled: '#595959',
  textInfo: '#C8A38A',
  textWarning: '#F5B452',
  textButton: '#FFF',
  textDanger: '#ED756E',
  success: '#57DB70',
  danger: '#FE534D',
  warningBg: '#F0AF41',
  tagBg: '#4B7EFFCC',
  bannerBg: '#222222',
  tagText: '#FFFFFF',
  exploreIndicator: '#4F8AE3',
  exploreIndicatorActive: '#4F8AE3',
  borderLine: '#523e8b80',

  gradients: {
    bubblegum: 'linear-gradient(139.73deg, #00DAFF 0%, #00FFB9 100%)',
    green2lightblue: '#151BE2',
    blue2indigo: 'linear-gradient(90deg, #3580FE -2.21%, #A633FE 100%)',
    walletMenuBg: 'linear-gradient(90deg, #1273ea 0%, #1c94f4 100%)',
    buttonNormal: 'linear-gradient(90deg, #00CB82 -2.21%, #00B4ED 100%)',
    buttonHover: 'linear-gradient(90deg, rgba(0, 203, 130, 0.5) -2.21%, rgba(0, 180, 237, 0.5) 100%)',
    buttonLoading: 'linear-gradient(90deg, rgba(0, 203, 130, 0.5) -2.21%, rgba(0, 180, 237, 0.5) 100%)',
    swapBorder: 'linear-gradient(90deg, #77acff -2.21%, #c578ff 89.35%);',
  },
  feedbacks: {
    successText: '#6EC25C',
    successBg: '#0b58204d',
    dangerText: '#ED756E',
    dangerBg: '#580b0b4d',
    warningText: '#F5B452',
    warningBg: '#FEF8EE4D',
    infoText: '#4F8AE3',
    infoBg: '#0007b74d',
    disableText: '#ADADAD',
    disableBg: '#443A4D',
    iconWarningUnstake: '#4F8AE3',
  },
  infoCard: {
    infoText: '#956DEB',
    infoBg: '#0007B7',
  },
  button: {
    primaryBg: '#D9B07A',
    secondaryBg: '#FFFFFF',
    tertiaryBg: '#524B40',
    quaternaryBg: '#DEEFFF',
    quaternaryText: '#4F8AE3',
    dangerBg: '#FFB2C04D',
    disabledBg: '#1D1D1D',
    primaryText: '#000000',
    dangerText: '#ED756E',
    linkText: '#BB8857',
    disabledText: '#77777780',
    radioOptionBg: '#F2F2F2',
    radioOptionText: '#5A5A5AB2',
    radioSelectedBg: '#0AC6E5',
    radioSelectedText: '#FAFAFA',
  },
  swap: {
    background: '#FFFFFF',
    migrationBannerBackground: 'linear-gradient(90.2deg, #EFE7F3 26.53%, #E0E2F7 71.19%)',
    migrationBannerBtnColor: '#FFFFFF',
  },
  shadows: {
    settings: '0px 4px 25px 0px #0024a426',
    navbar: '0px 4px 20px 0px #003D9814',
  },
  statusPill: {
    background: {
      open: '#4F8AE3',
      completed: '#56A944',
      closed: '#E0E0E0',
    },
    text: {
      open: '#FFFFFF',
      completed: '#FFFFFF',
      closed: '#777777',
    },
  },
  difficultyPill: {
    background: {
      beginner: '#C8EFD04D',
      intermediate: '#FEF8EE',
      advanced: '#FFB3C0',
    },
    text: {
      beginner: '#000000',
      intermediate: '#F5B452',
      advanced: '#ED756E',
    },
  },
  roiCalculator: {
    background: '#F6F6F6',
    footerBackground: '#F5FAFF',
    footerHeaderText: '#D9B07A',
    footerDetailsText: '#4F8AE3',
  },
  chart: {
    areaColor: 'transparent',
    bar1Color: '#524B40',
    bar2Color: '#D6BC8B',
    lineColor: '#8AC0FF',
    xAxisColor: '#9C9C9C',
    yAxisColor: '#9C9C9C',
    yAxis1Color: '#9C9C9C',
    yAxis2Color: '#9C9C9C',
    gradientArea: 'linear-gradient(184deg, rgba(138, 192, 255, 0.35) 1%, rgba(138, 192, 255, 0.07) 94.95%)',
    stopColorOne: 'rgba(109, 209, 255, 0.35)',
    stopColorTwo: 'rgba(109, 209, 255, 0.07)',
  },
}
